import { coreThemeColors } from '@youscience/theme';
import { PAGE_BACKGROUND } from '@theme';
import { styled } from '@mui/material';

const helperTextColor = '#FF4949';

export const sxStyles = {
  majorCheckBox: {
    display: 'flex',

    '& > span:first-of-type': {
      padding: '0',
      marginRight: '0.5rem',
    },
  },
  additionalCheckBox: {
    display: 'flex',
    alignItems: 'start',

    '& > span:first-of-type': {
      padding: '0 0.5rem 0',
    },
  },
  degrees: {
    margin: '1rem 1.75rem',
  },
  additionalProgramsTitle: {
    display: 'flex',
    alignItems: 'center',

    '& > svg:first-of-type': {
      marginRight: '0.5rem',
    },
  },
  cipCodeTooltip: {
    cursor: 'pointer',
  },
  helperText: {
    color: helperTextColor,
  },
};

export const StyledAdditionalPrograms = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  marginBottom: '1rem',
  padding: '1.75rem',
  borderRadius: '5px',
  backgroundColor: PAGE_BACKGROUND,
}));
